import { render, staticRenderFns } from "./CECard.vue?vue&type=template&id=63d90628&scoped=true&"
import script from "./CECard.vue?vue&type=script&lang=js&"
export * from "./CECard.vue?vue&type=script&lang=js&"
import style0 from "./CECard.vue?vue&type=style&index=0&id=63d90628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d90628",
  null
  
)

export default component.exports